import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import Panel from "@/shared/components/Panel";
import { ResponsiveContainer } from 'recharts';
import APIUsageDetails from './APIUsageDetail';
import ChartPieIcon from 'mdi-react/ChartPieIcon';
import { colorGreenHover } from '@/utils/palette';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import { colorAdditional, colorRedHover } from '@/utils/palette';
import ReactTableBase from '@/shared/components/table/ReactTableBase';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorRedHover};

    svg {
      fill: ${colorRedHover};
    }
  }

  &:hover .edit {
    color: ${colorGreenHover};

    svg {
      fill: ${colorGreenHover};
    }
  }
`;

const APIUsagesList = () => {
    const [selectedAPIUsage, setSelectedAPIUsage] = useState();
    const [APIUsagesList, setAPIUsagesList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: true,
        withSearchEngine: true,
        manualPageSize: [10, 20, 30, 40],
        placeholder: 'Search...',
    };

    const GetAPIUsagesData = () => {
        AdminInterface.instance.getServiceUsages().then((response) => {
            const columns = [
                {
                    accessor: 'user_id',
                    Header: 'User Id',
                    disableSortBy: true,
                },
                {
                    accessor: 'service',
                    Header: 'Service',
                    disableSortBy: true,
                },
                {
                    accessor: 'first_request_datetime',
                    Header: 'First Request Datetime',
                },
                {
                    accessor: 'latest_request_datetime',
                    Header: 'Latest Request Datetime',
                },
                {
                    accessor: 'count',
                    Header: 'Count',
                },
                {
                    accessor: 'detail',
                    Header: 'Detail',
                    disableGlobalFilter: true
                }
            ];
            const data = [];
            response.data.forEach(usage => {
                data.push({
                    user_id: usage.user_id,
                    service: usage.service,
                    first_request_datetime: usage.first_request_datetime !== null ? new Date(`${usage.first_request_datetime}z`).toLocaleString() : '',
                    latest_request_datetime: usage.latest_request_datetime !== null ? new Date(`${usage.latest_request_datetime}z`).toLocaleString() : '',
                    count: usage.count,
                    detail: <CartTableButton type="button" onClick={() => setSelectedAPIUsage(usage)} ><ChartPieIcon /></CartTableButton>,
                });
            });

            const APIUsagesListTableData = { tableHeaderData: columns, tableRowsData: data };
            setAPIUsagesList(APIUsagesListTableData);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        })
    };

    useEffect(() => {
        GetAPIUsagesData();
    }, []);

    return (
        <Col xs={12} md={12} lg={12}>
            <Row>
                <Panel lg={12} xl={12} md={12} title='API Usages By Service' refreshRequest={() => GetAPIUsagesData()}>
                    {APIUsagesList && <ResponsiveContainer >
                        <ReactTableBase
                            columns={APIUsagesList.tableHeaderData}
                            data={APIUsagesList.tableRowsData}
                            tableConfig={tableConfig} />
                    </ResponsiveContainer>}
                </Panel>
            </Row>
            {selectedAPIUsage &&
                <Row>
                    <APIUsageDetails selectedAPIUsage={selectedAPIUsage} setSelectedAPIUsage={setSelectedAPIUsage} />
                </Row>}
        </Col>
    );
};

APIUsagesList.propTypes = {
    APIUsagesListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default APIUsagesList;
